import vue from 'vue'
import filter from '../../assets/js/filters'
const that = vue.prototype
export default {
  copy (record, vm) {
    let obj = {
      direction: {
        note: '方向',
        item: record.direction === 'forward' ? '新乐-石家庄' : '石家庄-新乐'
      },
      mode: {
        note: '乘车方式',
        item: record.mode === 'carpooling' ? '拼车' : '包车'
      },
      travelTime: {
        note: '用车时间',
        item: filter.limitedTimeMount(record.travelTime)
      },
      startPlace: {
        note: '出发地',
        item: `${record.startPlace.city}-${record.startPlace.district}-${record.startPlace.title}`
      },
      endPlace: {
        note: '目的地',
        item: `${record.endPlace.city}-${record.endPlace.district}-${record.endPlace.title}`
      },
      phone: {
        note: '联系方式',
        item: record.phone
      },
      passengers: {
        note: '乘车人数',
        item: `${record.passengers}人`
      },
      remarks: {
        note: '备注',
        item: record.remarks || '---'
      }
    }
    let message = ''
    for (const i in obj) {
      if (Object.hasOwnProperty.call(obj, i)) {
        let item = obj[i]
        let str = item.note + ':\t' + item.item
        message += str + '\n'
      }
    }
    that.$copyText(message).then(e => {
      vm.$notification['success']({
        message: '操作成功',
        description: '复制成功'
      })
      console.log(e)
    }, function (e) {
      vm.$notification['success']({
        message: '网络错误',
        description: '复制失败'
      })
      console.log(e)
    })
  }
}
